<template>
    <div>
        <div class="options d-flex align-items-center m-3 justify-content-between">
            <!-- <search table="resources"></search> -->

            <div class="d-flex col-sm-3 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>
            </div>

            <button class="btn" @click="addResource">
                <i class="ico ico-add"></i> Add Resource
            </button>

            <!-- <export></export> -->
        </div>

        <div v-if="getLoadingResources" class="p-4 text-center">
            <loader></loader>
        </div>

        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Export from '@/tools/Export'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function() {
            return {
                searchQuery:null,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        name: this.formatName,
                        price: this.formatPrice,
                        availability: this.formatAvailability,
                        type: this.formatType,
                        isActive: this.formatIsActive,
                    },
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove,
                        }
                    ],
                },
                rowEvent: null,
            }
        },
        asyncComputed: {
            async types() {
                try {
                    let response = await axios.get('/api/settings/GetResourceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        computed: {
            ...mapGetters([
                'getResources',
                'getResourcesLabels',
                'account',
                'getLoadingResources'
            ]),
            header: function() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: this.getResourcesLabels,
                };
            },
            filteredResults: function() {
                if(this.searchQuery){
                    return this.getResources.filter(resource => {
                        return resource.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                    })
                } else {
                    return this.getResources
                }
            }
        },
        methods: {
            ...mapActions([
                'setSelectedItem',
                'initResources',
                'removeItem',
                'openModal',
            ]),
            view: function(item) {
                this.setSelectedItem({ table: 'resources', id: item.id });
                this.openModal('ResourceView');
            },
            addResource: function() {
                this.openModal('ResourceAdd')
            },
            remove: function(item) {
                this.removeItem({
                    table: 'resources',
                    object: 'resource',
                    module: 'inventory',
                    fields: { supplierId: this.account.supplierId, Resource: item }
                });
            },
            formatName: function(resource) {
                return '<div class="bold">' + resource.name + '</div>';
            },
            formatPrice: function(resource) {
                return '<div>' + resource.price + '</div><div class="sub">' + parseFloat(resource.priceType).toFixed(2) + '€' + '</div>';
            },
            formatAvailability: function(resource) {
                if (resource.availabilityType) {
                    return (resource.availability > 0) ? resource.availability + ' ' + resource.availabilityType : resource.availabilityType;
                }
                else {
                    return (resource.availability > 0) ? resource.availability : '-';
                }
            },
            formatShared: function(resource) {
                return resource.shared ? 'Yes' : 'No';
            },
            formatPrivate: function(resource) {
                return resource.private ? 'Yes' : 'No';
            },
            formatIsActive: function(resource) {
                return resource.isActive ? 'Active' : '<div class="color-6">Inactive</div>';
            },
        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// Resources.vue?024d7f16